export class Charger {
    public id!: number;
    public name!: string;
    public label!: string;
    public wattPower!: number;
}
